import React, { forwardRef } from "react";
import "./ItemDate.css";
import TauriImage from "../../../../../TauriImage/TauriImage";
import { accountMapping, sessionType } from "../../../../../../visualizations/visualizations";

const getToday = () => {
    const now = new Date();
    now.setHours(0, 0, 0, 0); // Ensures time doesn't affect the date
    return now.toLocaleDateString("en-CA");
};

const ItemDate = forwardRef(({ sessions, sessTime, onDateClick, hoveredAccount, showUnplanned, style }, ref) => {
    const today = getToday();

    const statusMappingNames = {
        0: ["pending"],
        1: ["success"],
        2: ["missed"],
        3: ["inprogress"],
        4: ["recovered"],
        5: ["advanced"],
        8: ["jointcall", "success"],
        9: ["jointcall", "recovered"],
        10: ["jointcall", "advanced"]
    };


    const statusIcon = {
        "pending": "/Images/material-symbols--pending-actions.svg",
        "success": "/Images/material-symbols--check.svg",
        "missed": "/Images/akar-icons--person-cross.svg",
        "inprogress": "/Images/mdi--hourglass.svg",
        "recovered": "/Images/mdi--check-decagram.svg",
        "advanced": "/Images/material-symbols--check-advanced.svg",
        "jointcall": "/Images/mdi--handshake-outline.svg"
    }

    // Normalize to 'en-CA' format
    const formattedDates = sessions.map(session => ({
        ...session,
        formatted: new Date(session.SessionDate).toLocaleDateString("en-CA")
    }));

    const hasToday = formattedDates.find(d => d.formatted === today);
    const pastDates = formattedDates.filter(d => new Date(d.formatted) < new Date(today));
    const futureDates = formattedDates.filter(d => new Date(d.formatted) > new Date(today));

    const formatDisplayDate = (date) =>
        new Date(date).toLocaleDateString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
        });

    return (
        <div ref={ref} className="item-date-popup" style={style}>
            {pastDates.map((date, index) => (
                <div
                    key={index}
                    className={`item-date-row item-date-details ${index % 2 === 0 ? '' : 'striped-color'}`}
                    onClick={() => onDateClick?.(date, sessionType.PastDue)}
                >
                    {statusMappingNames[date?.Status]?.map((st, i) => (
                        <TauriImage
                            key={i}
                            localImage={statusIcon[st]}
                            alt={st}
                            className="idp-icon"
                        />
                    ))}
                    <span>{formatDisplayDate(date.SessionDate)}</span>
                </div>
            ))}
            <div className={`item-date-row item-date-header ${hasToday ? 'has-today' : ''}`}>
                {hasToday ? (
                    statusMappingNames[hasToday?.Status]?.map((st, i) => (
                        <TauriImage
                            key={i}
                            localImage={statusIcon[st]}
                            alt={st}
                            className="idp-icon"
                        />
                    ))
                ) : (
                    <TauriImage
                        localImage="/Images/f7--calendar-today.svg"
                        alt="icon"
                        className="idp-icon"
                        color="#000"
                    />
                )}
                <span>{hasToday ? `Today, ${sessTime}` : "No Schedule Today"}</span>
                {(!hasToday && hoveredAccount?.Type === accountMapping.Agent) &&
                    <TauriImage
                        localImage="/Images/flat-color-icons--plus.svg"
                        className={"inci-icon"}
                        onClick={showUnplanned}
                        alt="brand-icon"
                    />
                }
            </div>

            <div className="item-date-divider" />

            {futureDates.length > 0 ? (
                futureDates.map((date, index) => (
                    <div
                        key={index}
                        className={`item-date-row item-date-details ${index % 2 === 0 ? '' : 'striped-color'}`}
                        onClick={() => onDateClick?.(date, sessionType.Advanced)}
                    >
                        {statusMappingNames[date?.Status]?.map((st, i) => (
                            <TauriImage
                                key={i}
                                localImage={statusIcon[st]}
                                alt={st}
                                className="idp-icon"
                            />
                        ))}
                        <span>{formatDisplayDate(date.SessionDate)}</span>
                    </div>
                ))
            ) : (
                <div className="item-date-row">
                    <span>No Future Schedule</span>
                </div>
            )}
        </div>
    );
});

export default ItemDate;
